/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useState } from "react";

import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

/* PANTALLAS BKI */
import TablaPropertiesView from "./TablaPropertiesView";
import Trazabilidad from "./Trazabilidad";
import DetallTramits from "./DetallTramits";
import TablaLogsEnviamentsView from "./TablaLogsEnviamentsView";
import TablaControlTramitsView from "./TablaControlTramitsView";
import TablaPathXMLView from "./TablaPathXMLView";
import { TraceFiltersProvider } from "../../contexts/trazabilidad/TraceFiltersContext";

function MantenimentMetataula() {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    menu: {
      width: "18%",
      backgroundColor: "#f1f1f1",
      padding: "20px",
      boxSizing: "border-box",
      marginTop: "50px",
    },
    link: {
      display: "block",
      margin: "10px 0",
      textDecoration: "none",
      color: "#A17400",
      fontSize: "15px",
      fontWeight: "bold",
      padding: "10px",
      "&:hover": {
        color: "white",
        backgroundColor: "#A17400",
      },
    },
    content: {
      width: "80%",
      backgroundColor: "#fff",
      padding: "20px",
      boxSizing: "border-box",
    },
    menu2: {
      position: "fixed",
    },
  }));

  const classes = useStyles();
  const [componenteActual, setComponenteActual] = useState("componente6");

  const handleLinkClick = (componente) => {
    setComponenteActual(componente);
  };

  const renderComponenteActual = () => {
    const componentes = {
      componente1: () => <DetallTramits />,
      componente2: () => <TablaPropertiesView />,
      componente3: () => (
        <TraceFiltersProvider>
          <Trazabilidad />
        </TraceFiltersProvider>
      ),
      componente4: () => <TablaLogsEnviamentsView />,
      componente5: () => <TablaControlTramitsView />,
      componente6: () => <TablaPathXMLView />,
    };

    const ComponenteActual =
      componentes[componenteActual] || componentes["componente3"];

    return ComponenteActual();
  };

  return (
    <div className={classes.container}>
      <div className={classes.menu}>
        <div className={classes.menu2}>
          <Link
            to="#"
            className={classes.link}
            onClick={() => handleLinkClick("componente1")}
          >
            Detall Tràmits
          </Link>
          <Link
            to="#"
            className={classes.link}
            onClick={() => handleLinkClick("componente2")}
          >
            Consulta Propierties
          </Link>
          <Link
            to="#"
            className={classes.link}
            onClick={() => handleLinkClick("componente3")}
          >
            Consulta Trazabilidad
          </Link>
          <Link
            to="#"
            className={classes.link}
            onClick={() => handleLinkClick("componente4")}
          >
            Consulta Logs Enviaments
          </Link>
          <Link
            to="#"
            className={classes.link}
            onClick={() => handleLinkClick("componente5")}
          >
            Control Tramits
          </Link>
          <Link
            to="#"
            className={classes.link}
            onClick={() => handleLinkClick("componente6")}
          >
            Consulta Paths XML
          </Link>
        </div>
      </div>
      <div className={classes.content}>{renderComponenteActual()}</div>
    </div>
  );
}
export default MantenimentMetataula;
